const validateNumber = (phoneNumber, numberLength, suffixLength, suffixFormat) => {
  const formattedPhoneNumber = phoneNumber.replace(/[^0-9]/g, '');
  if (formattedPhoneNumber.length !== numberLength || formattedPhoneNumber.substring(0, suffixLength) !== suffixFormat) {
    return phoneNumber;
  }
  return true;
};

export const validatePhoneNumber = {
  cl: phoneNumber => {
    return validateNumber(phoneNumber, 11, 3, '569');
  },
  pe: phoneNumber => {
    return validateNumber(phoneNumber, 11, 3, '519');
  },
  br: phoneNumber => {
    return validateNumber(phoneNumber, 13, 2, '55');
  }
};
